module.exports = __webpack_public_path__ + "img/horizontal_7_3_7042.6f287440.png";